/* eslint-disable no-unused-vars */
export default function allModels(
  Groups,
  Personas,
  Users,
  Calendar,
  Leave,
  Availability,
  Suppressions,
  ShiftLogs,
  Notes,
  Pages,
  Articles,
  Tasks,
  Notifications,
  Wages,
  OrgSettings,
  ChannelNotifications,
  LaborSettings,
  Subscription,
  Invoices
) {
  'ngInject';

  // NOTE: all the models (Groups, Users, etc) are imported here so they're always loaded
  // and restangularize works as expected
  return null;
}
